/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

export default [
  /*{
    url: "/admin",
    name: "Admin Home",
    slug: "admin-home",
    icon: "HomeIcon"
  },*/
  {
    url: "/admin/organization",
    name: "Company",
    slug: "company",
    icon: "TrelloIcon",
    i18n: "Company"
  },
  {
    url: "/admin/users",
    name: "User",
    slug: "user",
    icon: "UserIcon",
    i18n: "User"
  },
  {
    url: "/admin/coach-assignments",
    name: "Assign Coach",
    slug: "assign-coach",
    icon: "UsersIcon",
    i18n: "AssignCoach"
  },
  {
    url: "/admin/coaching-effectiveness",
    name: "Coaching Effectiveness",
    slug: "coaching-effectiveness",
    icon: "UserIcon",
    i18n: "CoachingEffectiveness"
  },
  // {
  //   url: "/user/player-details/all",
  //   name: "Trainee Details",
  //   slug: "trainee-details-view",
  //   icon: "UserIcon",
  //   i18n: "TraineeDetails"
  // },


];
